import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from 'locales/en/translation.json';
import ja from 'locales/ja/translation.json';

const defaultLanguage = 'ja';
const fallbackLng = 'ja';
const resources = {
  en: {
    translation: en
  },
  ja: {
    translation: ja
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: fallbackLng,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
